import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { request } from "@/js/http/http_request";
import { getIdUserFromToken } from "@/js/http/auth.js";
import { getFullNameUser as _getFullNameUser } from "@/js/user/user.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "CommentComponent",
  data: function data() {
    return {
      errorLabels: {
        comment: ""
      },
      errorMessages: {
        mandatory: "This field is required"
      },
      commentContainer: false,
      comments: [],
      comment: "",
      idParent: null,
      idComment: null,
      currentIdUser: null,
      apiUrl: "/v1/comment"
    };
  },
  components: {
    confirm: confirmationComponent
  },
  props: ["idOrder", "idCellarWine", "inboundDeliveryId", "btnClassSupp"],
  created: function created() {
    if (typeof this.$props.idCellarWine != "undefined") {
      this.idReference = this.$props.idCellarWine;
      this.referenceType = "cellar_wine";
    } else if (typeof this.$props.inboundDeliveryId != "undefined") {
      this.idReference = this.$props.inboundDeliveryId;
      this.referenceType = "order_dispatch";
    } else {
      this.idReference = this.$props.idOrder;
      this.referenceType = "order";
    }
    this.getComments();
    this.currentIdUser = getIdUserFromToken();
  },
  methods: {
    getComments: function getComments() {
      var instance = this;
      request(instance.apiUrl + "/" + instance.referenceType + "/" + instance.idReference, "get", null, true, "api").then(function (response) {
        instance.comments = _toConsumableArray(response.data);
      });
    },
    saveComment: function saveComment() {
      var callType;
      var data = {
        id_reference: this.idReference,
        reference_type: this.referenceType,
        id_comment: this.idComment,
        comment: this.comment
      };
      if (this.idComment == null || this.idComment == 0) {
        callType = "post";
      } else {
        callType = "put";
      }
      this.errorLabels.comment = "";
      if (this.comment == "") {
        this.errorLabels.comment = this.errorMessages.mandatory;
      } else {
        var instance = this;
        instance.$EventBus.$emit("loading", true);
        request(instance.apiUrl, callType, data, true, "api").then(function (response) {
          instance.getComments();
          instance.comment = "";
          instance.idComment = null;
          instance.$EventBus.$emit("loading", false);
        });
      }
    },
    prepareEditComment: function prepareEditComment(comment) {
      this.comment = comment.comment;
      this.idComment = comment.id_comment;
    },
    cancelEditComment: function cancelEditComment() {
      this.comment = "";
      this.idComment = null;
    },
    deleteComment: function deleteComment(idComment) {
      var instance = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this comment ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          instance.$EventBus.$emit("loading", true);
          request(instance.apiUrl + "/" + idComment, "delete", null, true, "api").then(function (response) {
            instance.getComments();
            //If currently editing : reset edit
            if (instance.idComment == idComment) {
              instance.cancelEditComment();
            }
            instance.$EventBus.$emit("loading", false);
          });
        }
      });
    },
    getFullNameUser: function getFullNameUser(user) {
      return _getFullNameUser(user);
    }
  }
};